import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	betaLozenge: {
		id: 'atlassian-intelligence.common.ai-footer.beta-lozenge',
		defaultMessage: 'Beta',
		description: 'Text in beta lozenge in the footer.',
	},
	disclaimerText: {
		id: 'atlassian-intelligence.common.ai-footer.disclaimer-text',
		defaultMessage: 'Content quality may vary',
		description: 'Info Text in the footer.',
	},
	longDisclaimerText: {
		id: 'atlassian-intelligence.common.ai-footer.long-disclaimer-text',
		defaultMessage: 'Content is based on your permissions, and its quality may vary',
		description: 'Long Info Text in the footer.',
	},
	shortAttributionText: {
		id: 'atlassian-intelligence.common.ai-footer.short-attribution-text',
		defaultMessage: 'Powered by AI',
		description: 'Short attribution info text in the footer.',
	},
	longAttributionText: {
		id: 'atlassian-intelligence.common.ai-footer.long-attribution-text',
		defaultMessage: 'Powered by Atlassian Intelligence',
		description: 'Long attribution info text in the footer.',
	},
	infoIconLabel: {
		defaultMessage: 'Info',
		id: 'atlassian-intelligence.common.ai-footer.info-icon-label',
		description: 'Label for info icon in disclaimer text.',
	},
	aiIconLabel: {
		defaultMessage: 'Atlassian Intelligence',
		id: 'atlassian-intelligence.common.ai-footer.ai-icon-label',
		description: 'Label for Atlassian Intelligence icon.',
	},
});
